var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { SchemaModuleUniversal } from './module-universal';
import * as rawJSONSchemaModulePainManagement from '../../schemas/module-pain-management.json';
var SchemaModulePainManagement = (function (_super) {
    __extends(SchemaModulePainManagement, _super);
    function SchemaModulePainManagement() {
        var _this = _super.call(this) || this;
        _this.loadSchema(rawJSONSchemaModulePainManagement);
        return _this;
    }
    return SchemaModulePainManagement;
}(SchemaModuleUniversal));
export { SchemaModulePainManagement };



// WEBPACK FOOTER //
// /var/www/schemas-forms/src/app/forms/module-pain-management.ts.pre-build-optimizer.js